<template>
  <SplitViewTemplate 
    :screenConfig="data" 
    :backButtonRoute="'/settings/production'" 
    :dataModel="formModel"
    :formConfig="setFormConfig" 
    :setLoading="setLoading" 
    :validationSummary="validationSummary"
    :ref="'production-processes'" 
    :defaultUserSettings="false" />
</template>
<script>
import { FeatureStorage } from "@/_services/storage";
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { DepartmentService } from "../../../_services/api/sales/department.service";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        Inactive: false,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
        DepartmentCode: null,
        IsCriticalProcess: false,
      },
      data: {
        title: "Production Processes",
        pageRoute: "/production-processes",
        saveEndPoint: "Process",
        updateEndPoint: "Process",
        updateKeyField: "Code",
        updateKeyFieldType: "string",
        recordEndPoint: "Process",
        exportFileName: "Production Process",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ProcessList",
              serverPaging: true,
              allowGrouping: false,
              filter: "",
              sort: [{ selector: "Description", desc: false }],
            },
            rowSelect: {
              view: this,
              page: "production-processes",
              mode: "review",
              idProperty: "Code",
            },
          },
          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/production-processes/create",
                clickAction: () => {
                  this.goToCreateProductionProcesses();
                },
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "ProductionSettings",
                  "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "Process",
              allowHiding: false,
              sortIndex: 0,
              sortOrder: "asc",
              gridDataField: "Description",
              dataField: "Description",
              filterIndex: 0,
              type: "Text",
            },
            {
              screenField: "Department",
              dataField: "DepartmentSearchText",
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "DepartmentDesc",
                  },
                ],
                secondary: [
                  {
                    dataField: "DepartmentCode",
                  },
                ],
              },
              exportFields: [
                {
                  "dataField": "DepartmentCode",
                  "label": "Department Code",
                  "alignment": "left"
                },
                {
                  "dataField": "DepartmentDesc",
                  "label": "Department Description"
                },
              ],
              filterIndex: 2,
              filterDataField: "DepartmentCode",
            },
            {
              screenField: "IsCriticalProcess",
              allowHiding: false,
              filterIndex: 3,
              dataSourceConfig: {
                data: [
                  { key: "Y", value: "Yes" },
                  { key: "N", value: "No" },
                ],
              },
              valueExpr: "key",
              displayExpr: "value",
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 1,
            },
          ],
          valueChangedEventListners: [],
        },
        recordPostProcess: this.recordPostProcess,
      },
      updatedDefaultRecordId: undefined,
      recordEditable: true,
    };
  },
  computed: {
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: FeatureStorage.checkPermission(
            this.$route.meta.applicationFeatureCode,
            "create"
          ),
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: false,
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
          editCallBack: () => {
            this.beforeInit();
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                editorType: "dxTextBox",
                editorOptions: {
                  tabIndex: 1,
                  maxLength: 3,
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Code" },
                visible: true,
                allowUpdate: this.baseView.mode == "create" ? true : false,
              },
              {
                dataField: "Description",
                editorType: "dxTextBox",
                editorOptions: {
                  tabIndex: 2,
                  maxLength: 25,
                },
                required: true,
                label: { text: "Description" },
                visible: true,
                allowUpdate: this.recordEditable,
              },
              {
                dataField: "DepartmentCode",
                label: { text: "Department" },
                editorType: "dxSelectBox",
                required: true,
                editorOptions: {
                  tabIndex: 3,
                  dataSource: DepartmentService.dataSourceConfig(
                    "api/DepartmentList",
                    {
                      select: ["Code", "Description"],
                      filter: this.baseView.mode == "create" ?
                        ["Inactive", "=", "N"] :
                        [
                          [
                            "Code",
                            "=",
                            this.formModel["DepartmentCode"]
                          ],
                          "or",
                          ["Inactive", "=", "N"]
                        ],
                      sort: [{ selector: "Description", asc: true }],
                    }
                  ),
                  valueExpr: "Code",
                  displayExpr: (item) => {
                    if (item) return item.Description + " - " + item.Code;
                    else return "";
                  },
                  itemTemplate: (data) => {
                    return ` <div class="custom-auto-complete" id="${data.Code}" >
                      <span class="auto-complete-primary">
                        ${data.Description}
                      </span>
                      <span class="record-secondary gc-grid-code">
                        ${data.Code}
                      </span> 
                    </div>`;
                  },
                  searchExpr: ["SearchText"],
                  searchMode: "contains",
                  showClearButton: true,
                  searchEnabled: true,
                },
              },
            ],
          },
          {
            itemType: "group",
            caption: "Cost Rates ($/ hr)",
            colCount: 1,
            items: [
              {
                screenField: "ResourceRate",
                dataField: "LabourResource",
                editorOptions: {
                  tabIndex: 4,
                },
                required: true,
                label: { text: "Labour Resource" },
                allowUpdate: this.recordEditable,
                cssClass: "dx-numberbox-left",
                validationRules: [
                  {
                    type: "range",
                    message: "Labour Resource must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                screenField: "FactoryOverhead",
                dataField: "FBurden",
                editorOptions: {
                  tabIndex: 5,
                },
                required: true,
                label: { text: "Factory Overhead" },
                allowUpdate: this.recordEditable,
                cssClass: "dx-numberbox-left",
                validationRules: [
                  {
                    type: "range",
                    message: "Factory Overhead must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                screenField: "AdminOverhead",
                dataField: "Burden1",
                editorOptions: {
                  tabIndex: 6,
                },
                required: true,
                label: { text: "Admin Overhead" },
                allowUpdate: this.recordEditable,
                cssClass: "dx-numberbox-left",
                validationRules: [
                  {
                    type: "range",
                    message: "Admin Overhead must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                screenField: "SalesOverhead",
                dataField: "Burden2",
                editorOptions: {
                  tabIndex: 7,
                },
                required: true,
                label: { text: "Sales Overhead" },
                allowUpdate: this.recordEditable,
                cssClass: "dx-numberbox-left",
                validationRules: [
                  {
                    type: "range",
                    message: "Sales Overhead must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
            ],
          },
          {
            itemType: "group",
            caption: "Sell Rate ($/hr)",
            colCount: 1,
            items: [
              {
                screenField: "ResourceRate",
                dataField: "SellRate",
                editorOptions: {
                  tabIndex: 8,
                },
                required: true,
                label: { text: "Labour Resource" },
                allowUpdate: this.recordEditable,
                cssClass: "dx-numberbox-left",
                validationRules: [
                  {
                    type: "range",
                    message: "Labour Resource must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
            ],
          },
          {
            itemType: "group",
            caption: "Schedule Settings",
            colCount: 1,
            items: [
              {
                screenField: "LeadDay",
                dataField: "LeadDay",
                editorType: "dxNumberBox",
                format: "0##",
                editorOptions: {
                  tabIndex: 9,
                  format: "0##",
                  onInput: (e) => {
                    const inputElement = e.event.target;
                    if (inputElement.value.length > 9)
                      inputElement.value = inputElement.value.slice(0, 9);
                  },
                },
                required: true,
                label: { text: "Lead Days" },
                allowUpdate: this.recordEditable,
                cssClass: "dx-numberbox-left",
                validationRules: [
                  {
                    type: "range",
                    message: "Lead Days must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                screenField: "ScheduleLeadTime",
                dataField: "ScheduleLeadTime",
                editorType: "dxNumberBox",
                format: "0#",
                editorOptions: {
                  tabIndex: 10,
                  format: "0#",
                  onInput: (e) => {
                    const inputElement = e.event.target;
                    if (inputElement.value.length > 9)
                      inputElement.value = inputElement.value.slice(0, 9);
                  },
                },
                required: true,
                label: { text: "Startup (mins)" },
                allowUpdate: this.recordEditable,
                cssClass: "dx-numberbox-left",
                validationRules: [
                  {
                    type: "range",
                    message: "Startup (mins) must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                screenField: "WorkOrderChangeOverTime",
                dataField: "WorkOrderChangeOverTime",
                editorType: "dxNumberBox",
                format: "0#",
                editorOptions: {
                  tabIndex: 11,
                  format: "0#",
                  onInput: (e) => {
                    const inputElement = e.event.target;
                    if (inputElement.value.length > 9)
                      inputElement.value = inputElement.value.slice(0, 9);
                  },
                },
                required: true,
                label: { text: "WO Change Over (mins)" },
                allowUpdate: this.recordEditable,
                cssClass: "dx-numberbox-left",
                validationRules: [
                  {
                    type: "range",
                    message: "WO Change Over (mins) must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                screenField: "ScheduleCompletionTime",
                dataField: "ScheduleCompletionTime",
                editorType: "dxNumberBox",
                format: "0#",
                editorOptions: {
                  tabIndex: 12,
                  format: "0#",
                  onInput: (e) => {
                    const inputElement = e.event.target;
                    if (inputElement.value.length > 9)
                      inputElement.value = inputElement.value.slice(0, 9);
                  },
                },
                required: true,
                label: { text: "Completion (mins)" },
                allowUpdate: this.recordEditable,
                cssClass: "dx-numberbox-left",
                validationRules: [
                  {
                    type: "range",
                    message: "Completion (mins) must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                dataField: "IsCriticalProcess",
                editorType: "dxSwitch",
                label: {
                  text: "Critical Process",
                },
                editorOptions: {
                  tabIndex: 13,
                },
              },
            ],
          },
          {
            itemType: "group",
            caption: "Lead Times",
            colCount: 1,
            items: [
              {
                screenField: "LeadWorkOrder",
                dataField: "LeadWo",
                editorOptions: {
                  tabIndex: 14,
                },
                required: true,
                label: { text: "Work Order" },
                allowUpdate: this.recordEditable,
                cssClass: "dx-numberbox-left",
                validationRules: [
                  {
                    type: "range",
                    message: "Work Order must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                screenField: "LeadProcess",
                dataField: "LeadProcess",
                editorOptions: {
                  tabIndex: 15,
                },
                required: true,
                label: { text: "Process" },
                allowUpdate: this.recordEditable,
                cssClass: "dx-numberbox-left",
                validationRules: [
                  {
                    type: "range",
                    message: "Process must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
  },
  methods: {
    goToCreateProductionProcesses() {
      this.$router
        .push({
          path: `/production-processes/create`,
        })
        .then(() => {
          this.recordEditable = true;
        });
    },
    beforeInit() {
      this.recordEditable = true;
    },
    overWritePayload(payload) {
      payload.Type = "P";
      payload.IsCriticalProcess = payload.IsCriticalProcess ? "Y" : "N";
      return payload;
    },
    recordPostProcess(data) {
      data["IsCriticalProcess"] = data["IsCriticalProcess"] == "Y" ? true : false;
      return data;
    },
  },
  created() {
    this.beforeInit();
  },
};
</script>
